//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("assistanceInList", AssistanceInListFactory);

    AssistanceInListFactory.$inject = ["apiClientFactory"];
    function AssistanceInListFactory(apiClientFactory) {

        const routePrefix = "api/assistance-in/lists/";

        return {
            DownloadExcel: apiClientFactory.get(routePrefix + "Excel/"),
            Get: apiClientFactory.get(routePrefix),
            GetFinished: apiClientFactory.get(routePrefix + "finished/"),
            Search: apiClientFactory.post(routePrefix),
            SearchFinished: apiClientFactory.post(routePrefix + "finished/"),
            SearchRequests: apiClientFactory.post(routePrefix + "requests/"),
        };
    }
})();
